import { Directive, Input, OnInit } from '@angular/core';
import { TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureToggleService } from 'app/services';

@Directive({
  selector: '[appFeatureEnabled]',
})
export class FeatureToggleDirective implements OnInit {
  @Input('appFeatureEnabled')
  featureCode = '';

  constructor(
    private featureToggleService: FeatureToggleService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  async ngOnInit() {
    const isFeatureEnabled = (await this.featureToggleService.getFeatureToggle(this.featureCode)).enabled;
    console.log(`feature ${this.featureCode} status enabled = ${isFeatureEnabled}`);
    if (isFeatureEnabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    this.viewContainer.clear();
  }
}
